import type { ButtonHTMLAttributes } from 'react';
import { cn } from './cn';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'secondary' | 'danger' | 'danger-text' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
};

const variants = {
  primary: 'bg-accent text-white hover:bg-accent-strong',
  secondary: 'bg-paper text-ink border border-line hover:bg-ground',
  danger: 'bg-danger text-white hover:brightness-110',
  'danger-text': 'bg-transparent text-danger hover:bg-red-50', // опасное, но не главное действие: не притягивает глаз
  ghost: 'bg-transparent text-ink hover:bg-ground',
};
const sizes = { sm: 'px-3 h-8 min-h-0 text-sm', md: 'px-4 py-2 text-base', lg: 'px-5 py-3 text-lg' };

export function Button({ variant = 'primary', size = 'md', className, type = 'button', ...rest }: Props) {
  return (
    <button
      type={type}
      className={cn(
        'inline-flex items-center justify-center gap-2 rounded-md font-semibold transition-colors',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        variants[variant], sizes[size], className,
      )}
      {...rest}
    />
  );
}
